import {SolidColor} from 'common/src/modules/movie/moviePrimitives.types';
import {MovieFillType} from 'common/src/modules/movie/movie.enums';
import simpleMovieValue from 'common/src/modules/movie/utils/simpleMovieValue';

function createDefaultColor([r, g, b]: [number, number, number] = [0, 0, 0]): SolidColor {
  return {
    t: MovieFillType.Solid,
    a: simpleMovieValue([1]),
    o: {
      c: simpleMovieValue([r, g, b, 255]),
    },
  };
}

export default createDefaultColor;
